import type { EventDetail } from "@cdt/shared";
import { AlertCircle } from "lucide-react";

import { CopyableId } from "@/components/events/detail/CopyableId";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { formatDateTimeLong } from "@/lib/formatters";

interface EventProcessingMetadataProps {
  event: EventDetail;
}

export function EventProcessingMetadata({
  event,
}: EventProcessingMetadataProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Metadata processing</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <dl className="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2 text-sm">
          <div>
            <dt className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
              Creato
            </dt>
            <dd className="mt-1">{formatDateTimeLong(event.createdAt)}</dd>
          </div>
          <div>
            <dt className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
              Ultimo aggiornamento
            </dt>
            <dd className="mt-1">{formatDateTimeLong(event.updatedAt)}</dd>
          </div>
          <div>
            <dt className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
              Retry count
            </dt>
            <dd className="mt-1">{event.retryCount}</dd>
          </div>
          <div className="md:col-span-2">
            <dt className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
              Email message ID
            </dt>
            <dd className="mt-1">
              <CopyableId value={event.emailMessageId} />
            </dd>
          </div>
          <div className="md:col-span-2">
            <dt className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
              Calendar event ID
            </dt>
            <dd className="mt-1">
              {event.calendarEventId ? (
                <CopyableId value={event.calendarEventId} />
              ) : (
                <span className="text-muted-foreground">-</span>
              )}
            </dd>
          </div>
        </dl>

        {event.errorMessage && (
          <div className="flex items-start gap-2 rounded-md border border-destructive/40 bg-destructive/5 p-3 text-sm text-destructive">
            <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" />
            <div>
              <div className="font-medium">Errore</div>
              <div className="mt-1 whitespace-pre-wrap break-words font-mono text-xs">
                {event.errorMessage}
              </div>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
